const EnUs = {
    welcome: "welcome"
}

export default EnUs;